









































































































































import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator";
import StepHead from "../Stepper/StepHead.vue";
import PersonContacts from "../FormParts/PersonForm/PersonContacts.vue";
import { InsuranceCard } from "@/services/index.defs";
import { getPlural } from "_P/strings";
import { ValidationRules } from "_P/validate";
import { GaHelper } from "@/core/helpers/ga";
@Component({ components: { StepHead, PersonContacts } })
export default class Step3 extends Vue {
    getPlural = getPlural;
    Rules = ValidationRules;

    isSms = false;
    code: string = "";

    errorText: string = "";
    processText: string = "";
    loading = false;
    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }

    created() {
        this.$store.direct.commit.insurance.initSmsTimers();
    }
    mounted() {
        GaHelper.send("contacts");
    }

    checkedPhone = "";
    @Watch("card.insurer.phone") async checkIfPhoneAuthorized(val: string) {
        if (val?.[0] != "7" || val?.length != 11) return;
        this.loading = true;
        try {
            if (this.checkedPhone == this.card.insurer.phone) return;
            this.checkedPhone = this.card.insurer.phone;
            let resp = await this.$store.direct.dispatch.insurance.checkPhoneStatus(
                this.card.insurer.phone
            );
            if (resp.success) {
                this.$store.state.insurance.confirmedPhone = this.card.insurer.phone;
                this.errorText = "";
            }
        } finally {
            this.loading = false;
        }
    }

    get phoneConfirmed() {
        return true;
        // Отключено в рамках задачи FLOWFIX-2425
        /*return (
            this.$store.direct.state.insurance.confirmedPhone &&
            this.$store.direct.state.insurance.confirmedPhone ==
                this.card.insurer.phone
        );*/
    }
    async getCode() {
        if (this.smsDisabled || !this.isValidContactFrom) return;
        let resp = null;
        try {
            resp = await this.$store.direct.dispatch.insurance.sendPhoneCode(
                this.card.insurer.phone
            );
            if (!resp.success) return;
        } catch (e) {
            console.error(e);
        }
        if (resp?.data) {
            this.moveToNextStep();
        } else {
            this.processText = "СМС отправлено на указанный номер";
            this.errorText = "";
            this.isSms = true;
        }
    }
    get smsTimer(): number {
        return this.$store.direct.state.insurance.smsTimer;
    }
    get smsDisabled(): boolean {
        return this.$store.direct.state.insurance.smsDisabled;
    }

    moveToNextStep() {
        if (!this.isValidContactFrom) return;
        this.$store.state.insurance.confirmedPhone = this.card.insurer.phone;
        this.errorText = "";
        this.$emit("next");
    }

    async checkCode() {
        if (!this.isValidContactFrom || !this.isValidSmsFrom) return;
        if (!this.code || isNaN(+this.code)) return;
        this.processText = "";
        const res = await this.$store.direct.dispatch.insurance.checkPhoneCode({
            phone: this.card.insurer.phone,
            code: this.code
        });
        if (res.success) this.moveToNextStep();
        else {
            this.errorText = res.error;
            console.log(res.error);
        }
    }

    @Ref("contactForm") contactForm: { validate: Function };
    get isValidContactFrom(): boolean {
        return this.contactForm.validate();
    }
    @Ref("smsForm") smsForm: { validate: Function };
    get isValidSmsFrom(): boolean {
        return this.smsForm.validate();
    }
}
